<template>
  <div class="role-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>角色名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入角色名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>角色类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.type" class="app-block" placeholder="请选择角色类型">
              <a-select-option :value="1">平台</a-select-option>
              <a-select-option :value="0">社区</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newRole()">新增角色</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="type" slot-scope="text, data">
        <a-tag color="blue" v-if="data.type === 1">平台</a-tag>
        <a-tag color="green" v-else>社区</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="assignMenu(data)" v-if="!data.showMenuLoading">分配菜单</a-button>
          <a-icon type="loading" v-else></a-icon>
          <a-button type="link" @click="editRole(data)">编辑</a-button>
          <a-button type="link" @click="deleteRole(data)">删除</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" :confirm-loading="modal.loading" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.menu" @changeHalfCheckedData="changeHalfCheckedData" :data="tree.data" :params="tree.params" multiple :check-strictly="false"></tree-select>
    </a-modal>
  </div>
</template>

<script>
  import RoleService from '@/io/role.js';
  import UserService from '@/io/user.js';

  export default {
    name: 'RoleManage',
    data() {
      let self = this;
      return {
        modal: {
          id: null,
          title: '分配菜单',
          show: false,
          menu: [],
          halfCheckedMenu: [],
          loading: false
        },
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'title',
            key: 'id'
          }
        },
        table: {
          loading: false,
          search: {
            name: null,
            type: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '角色名称',
              dataIndex: 'title'
            },
            {
              title: '角色类型',
              scopedSlots: { customRender: 'type' }
            },
            {
              title: '角色描述',
              dataIndex: 'describe'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    activated() {
      this.initData();
    },
    methods: {
      formatTree(data, checked) {
        return data.map(val => {
          return {
            id: val[this.tree.params.key],
            checked: checked ? 'true' : 'false'
          }
        });
      },
      confirmModal() {
        this.modal.loading = true;
        RoleService.assignMenu(this.modal.id, this.formatTree(this.modal.menu, true).concat(this.formatTree(this.modal.halfCheckedMenu, false))).then(res => {
          this.$afterFormSubmit('编辑成功', () => {
            this.initData();
          });
        }).catch(err => {}).finally(() => {
          this.modal.show = false;
          this.modal.loading = false;
        });
      },
      changeHalfCheckedData(data) {
        this.modal.halfCheckedMenu = data;
      },
      newRole() {
        this.table.page.current = 1;
        this.$router.push('/platform/role_manage/new');
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initTreeData(data) {
        data.showMenuLoading = true;
        return UserService.menuList(data.type).then(res => {
          this.tree.data = res;
        }).catch(err => {}).finally(() => {
          data.showMenuLoading = false;
        });
      },
      initData() {
        this.table.loading = true;
        return RoleService.listPage(
          this.table.search.name,
          this.table.search.type,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.showMenuLoading = false;
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
      assignMenu(data) {
        let ids = data.permissions.filter(val => val.pivot.checked === 'true').map(val => val.id);
        let halfIDs = data.permissions.filter(val => val.pivot.checked === 'false').map(val => val.id);
        let menu = [];
        let halfMenu = [];
        this.initTreeData(data).then(res => {
          this.$depthSearchTree(node => {
            if (ids.indexOf(node[this.tree.params.key]) > -1) {
              menu.push(node);
            }
            if (halfIDs.indexOf(node[this.tree.params.key]) > -1) {
              halfMenu.push(node);
            }
          }, this.tree.data);
          this.modal.id = data.id;
          this.modal.menu = menu;
          this.modal.halfCheckedMenu = halfMenu;
          this.modal.show = true;
        }).catch(err => {});
      },
      editRole(data) {
        this.$router.push(`/platform/role_manage/edit/${data.id}`);
      },
      deleteRole(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此角色？',
          onOk() {
            RoleService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>